<template>
	<div class="cont">
		<div>
			<div id="turnpage" class="turnpage">
				<div v-for="(item,index) in imagesList" :key="index"
					:style="` background:url(${item}) no-repeat 100% 100%; background-size:100% 100%;height:100px;`">
					<div class="pagenum">第{{index+1}}页</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import turn from '@/utils/turn.js'
	export default {
		name: 'Home',
		data() {
			return {
				lastX: null,
				lastY: null,
				imagesList: [require('@/assets/1.jpg'), require('@/assets/2.jpg'), require('@/assets/3.jpg'), require(
					'@/assets/4.jpg'), require('@/assets/5.jpg'), require('@/assets/6.jpg'), require(
					'@/assets/7.jpg')]
			}
		},
		mounted() {
			let that = this
			that.onTurn();
		},

		methods: {
			onTurn() {
				this.$nextTick(() => {
					$('#turnpage').turn({
						acceleration: true, //启用硬件加速,移动端有效
						display: 'double', //显示：single=单页，double=双页，默认双页
						duration: 800, // 翻页撒开鼠标，页面的延迟
						page: 1, // 默认显示第几页	
						gradients: true, // 折叠处的光泽渐变，主要体现翻页的立体感、真实感
						autoCenter: true, //自动居中, 默认false
						turnCorners: 'bl,br', // 设置可翻页的页角(都试过了，乱写 4个角都能出发卷起)， bl,br   tl,tr   bl,tr 
						height: 700, //页面高度
						width: 1000, //翻书范围宽度，总宽度
						direction: "ltr", //翻书的方向 如rtl 初始向左翻  ltr初始向有翻
					})
					$("#turnpage").turn("peel", "br"); // 在右下角显示角
				})
			},
		}
	}
</script>
<style scoped>
	.cont {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}
	.turnpage {
		margin: 100px auto !important;
		box-shadow: 0 0 0 10px #f3f3f3;
	}
	.pagenum {
		width: 100px;
		background: rgba(255, 255, 255, .3);
		line-height: 30px;
		position: absolute;
		bottom: 0px;
		left: 50%;
		margin-left: -50px;

	}
</style>